exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#sidebar-carousel .carousel-item[data-v-763cd163]{text-align:center}#sidebar-carousel .carousel-item img[data-v-763cd163]{margin:0 auto;width:60%}#sidebar-carousel .carousel-inner[data-v-763cd163]{height:auto}#sidebar-carousel .carousel-inner>.item>a>img[data-v-763cd163],#sidebar-carousel .carousel-inner>.item>img[data-v-763cd163]{margin:auto;min-height:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-763cd163","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/overall_layouts/sidebar-carousel.vue
// module id = 618
// module chunks = 0